export default {
  name: 'password-input',
  props: ['value', 'classname', 'id'],

  data () {
    return {
      visible: false,
    }
  },

  methods: {
    toggleVisibility () {
      this.visible = !this.visible;
    },

    updateValue (value) {
      this.$emit('input', value)
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    const inputType = this.visible ? "text" : "password";
    const iconClass = `mdi ${this.visible ? "mdi-eye-off" : "mdi-eye"}`;

    return (
      <div class="flex relative">
        <input type={inputType} id={this.id || "password"}
               class={"bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline " + this.classname}
               value={this.value}
               on-input={e => this.updateValue(e.target.value)}/>
        <div class="absolute right-0 cursor-pointer leading-9 mr-3" onClick={this.toggleVisibility}>
          <i class={iconClass}></i>
        </div>
      </div>
    );
  }
}
